import { FilterTreeNode, SelectedFilters } from '@opallabs/wormhole/types'

/**
 * Takes the full tree of filter options stored in the Redux store
 * and returns a map of all the options and child options
 */
export function buildFilterTreeMap(
  filterTree: Array<FilterTreeNode> | undefined,
  treeMap: Record<string, FilterTreeNode> = {}
): Record<string, FilterTreeNode> {
  if (!filterTree) return {}

  return filterTree.reduce((tm, node) => {
    tm[node.id] = node
    if (node.childOptions) {
      return buildFilterTreeMap(node.childOptions, tm)
    }
    return tm
  }, treeMap)
}
/**
 * Takes an filterTreeMap from buildFilterTreeMap and the selected filters from the
 * Redux store and returns an object of search param keys and their UUIDs to be
 * added to a URLSearchParams object
 */
export function getSelectedFilterParams(
  filterTreeMap: Record<string, FilterTreeNode>,
  selectedFilters: SelectedFilters
) {
  return {
    labels: getQueryString(
      Object.values(selectedFilters.labels || {}).flatMap((labels) =>
        labels
          .filter((l) => !l.disabled)
          .map(
            (l) =>
              filterTreeMap[`label-${l.id}`] &&
              filterTreeMap[`label-${l.id}`].uuid
          )
      )
    ),
    statuses: getQueryString(
      selectedFilters.status?.filter((l) => !l.disabled).map((s) => s.id)
    ),
    accounts: getQueryString(
      selectedFilters.account
        ?.filter((a) => !a.disabled)
        .map(
          (a) =>
            filterTreeMap[`channel-${a.id}`] &&
            filterTreeMap[`channel-${a.id}`].uuid
        )
    ),
    channels: getQueryString(
      selectedFilters.service
        ?.filter((c) => !c.disabled)
        .map(
          (c) =>
            filterTreeMap[`channel-${c.id}`] &&
            filterTreeMap[`channel-${c.id}`].uuid
        )
    ),
  }
}

function getQueryString(ids: Array<string | undefined> = []) {
  return (
    Array.from(
      ids.reduce((set, item) => {
        if (item) {
          set.add(item)
        }
        return set
      }, new Set())
    ).join(',') || ''
  )
}
